import { StoreInfo } from 'types/store/StoreTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedData } from 'types/common/FormTypes';
import { MerchantInfo } from 'types/info/merchant';
import { UserInfo } from 'types/info/user';
import { StoreCodes } from 'types/store/StoreTypes';

interface InfoState {
  merchant: MerchantInfo | Record<string, never>;
  isMerchantLoaded: boolean;
  user: UserInfo | Record<string, never>;
  isUserLoading: boolean;
  isUserLoaded: boolean;
  branches: SelectedData[];
  branchCodes: StoreCodes[];
  isBranchesLoaded: boolean;
  StoresInfo: StoreInfo[];
  storeName: string;
  storeType: number | null;
}

export const initialState: InfoState = {
  merchant: {} as MerchantInfo,
  isMerchantLoaded: false,
  user: {} as UserInfo,
  isUserLoading: false,
  isUserLoaded: false,
  branches: [],
  branchCodes: [],
  isBranchesLoaded: false,
  StoresInfo: [],
  storeName: '',
  storeType: null,
};

const InfoSlice = createSlice({
  name: 'Info',
  initialState,
  reducers: {
    setMerchant: (
      state,
      action: PayloadAction<MerchantInfo | Record<string, never>>
    ) => {
      state.merchant = action.payload;
    },
    setIsMerchantLoaded: (state, action: PayloadAction<boolean>) => {
      state.isMerchantLoaded = action.payload;
    },
    setUser: (
      state,
      action: PayloadAction<UserInfo | Record<string, never>>
    ) => {
      state.user = action.payload;
    },
    setIsUserLoaded: (state, action: PayloadAction<boolean>) => {
      state.isUserLoaded = action.payload;
    },
    setIsUserLoading: (state, action: PayloadAction<boolean>) => {
      state.isUserLoading = action.payload;
    },
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
    setBranchCodes: (state, action) => {
      state.branchCodes = action.payload;
    },
    setIsBranchesLoaded: (state, action: PayloadAction<boolean>) => {
      state.isBranchesLoaded = action.payload;
    },
    setStoresInfo: (state, action) => {
      state.StoresInfo = action.payload;
    },
    setStoreName: (state, action) => {
      state.storeName = action.payload;
    },
    setStoreType: (state, action) => {
      state.storeType = action.payload;
    },
  },
});

export const {
  setMerchant,
  setIsMerchantLoaded,
  setUser,
  setIsUserLoaded,
  setIsUserLoading,
  setBranches,
  setBranchCodes,
  setIsBranchesLoaded,
  setStoresInfo,
  setStoreName,
  setStoreType,
} = InfoSlice.actions;

export default InfoSlice.reducer;
